import { z } from 'zod';
import { catalogListQuerySchema } from './catalog';
import { idSchema, intSchema, moneySchema, optionalText, requiredText } from './common';

export const componentCreateSchema = z.object({
  name: requiredText(120, 'Descrição'),
  partNumber: optionalText(80, 'Código / part number'),
  /** Tipo cadastrado (`null` = sem tipo). */
  typeId: z.string().uuid('Tipo inválido').nullish(),
  packageType: optionalText(40, 'Encapsulamento'),
  location: optionalText(80, 'Localização'),
  minStock: intSchema('Estoque mínimo', 0, 100_000).optional(),
  costPrice: moneySchema.optional(),
  salePrice: moneySchema.optional(),
  notes: optionalText(500, 'Observações'),
  /** Estoque inicial — só vale no cadastro e só o administrador pode informar. */
  initialStock: intSchema('Estoque inicial', 0, 1_000_000).optional(),
  active: z.boolean().optional(),
});
export const componentUpdateSchema = componentCreateSchema.omit({ initialStock: true }).partial();
export type ComponentCreateInput = z.infer<typeof componentCreateSchema>;
export type ComponentUpdateInput = z.infer<typeof componentUpdateSchema>;
export type ComponentFormValues = z.input<typeof componentCreateSchema>;

/** Uso de um componente numa OS (uso interno). */
export const orderComponentCreateSchema = z.object({
  componentId: idSchema,
  quantity: intSchema('Quantidade', 1, 10_000),
});
export type OrderComponentCreateInput = z.infer<typeof orderComponentCreateSchema>;
export type OrderComponentFormValues = z.input<typeof orderComponentCreateSchema>;

/** Tipos de componente (cadastro auxiliar). */
export const componentTypeCreateSchema = z.object({ name: requiredText(60, 'Nome do tipo') });
export const componentTypeUpdateSchema = z.object({
  name: requiredText(60, 'Nome do tipo').optional(),
  active: z.boolean().optional(),
});
export type ComponentTypeCreateInput = z.infer<typeof componentTypeCreateSchema>;
export type ComponentTypeUpdateInput = z.infer<typeof componentTypeUpdateSchema>;

export const componentListQuerySchema = catalogListQuerySchema.extend({ typeId: idSchema.optional() });
export type ComponentListQuery = z.infer<typeof componentListQuerySchema>;
